import { lazy } from 'react';

export const TestDesignerList = lazy(() => import('./TestDesignerList'));
export const AddTestDesigner = lazy(() => import('./AddTestDesigner'));
export const UpdateTestDesigner = lazy(() => import('./UpdateTestDesigner'));
export const TestDesignerDetails = lazy(() => import('./TestDesignerDetails'));
